import { SAVE_BEAUTY_CONSULTATION_DIAGNOSIS_USER_DATA, SAVE_BEAUTY_CONSULTATION_DIAGNOSIS } from '@/redux/constants';

const defaultState = {
  userData: {
    name: null,
  },
  result: {
    treatments: {},
    hairDiagnosis: {
      hearing: {
        Questions: [],
      },
      stylistDiagnosis: {
        Questions: [],
      },
    },
    scalpDiagnosis: {
      hearing: {
        Questions: [],
      },
      stylistDiagnosis: {
        Questions: [],
      },
    },
  },
};

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case SAVE_BEAUTY_CONSULTATION_DIAGNOSIS_USER_DATA:
      return {
        ...state,
        userData: payload,
      };
    case SAVE_BEAUTY_CONSULTATION_DIAGNOSIS:
      return {
        ...state,
        results: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/beautyConsultationDiagnosis.js